/**
 * @ngInject
 */

function momentize () {
    function link (scope, elem, attrs) {
        
        moment.locale(wpmlLang);

        console.log("moment-local", moment(attrs.momentize.toString(), attrs.momentizeParse).format(attrs.momentizeDisplay));
        console.log("moment-utc", moment.utc(attrs.momentize.toString(), attrs.momentizeParse).format(attrs.momentizeDisplay));

        function onUpdate(){
            elem.text(moment(attrs.momentize.toString(), attrs.momentizeParse).format(attrs.momentizeDisplay));
        }
        attrs.$observe('momentize', onUpdate);
        attrs.$observe('momentizeDisplay', onUpdate);
    }

    return {
        restrict : 'A',
        link : link
    };
}